export default __webpack_public_path__ + "static/media/22-1.94b57b5c.mp3";